import React from 'react';
import {firebaseRoot} from './utils/firebase-utils';
import ReactFireMixin from 'reactfire';

const UserRef = React.createClass({
    mixins: [
        ReactFireMixin
    ],

    childContextTypes: {
        userRef: React.PropTypes.object.isRequired,
        firebaseRoot: React.PropTypes.object.isRequired
    },

    getInitialState() {
        return {
            userRef: null
        };
    },

    componentWillMount() {
        let auth = firebaseRoot.getAuth();
        if (auth) {
            this.bindAsDataSnapshot(firebaseRoot.child("users").child(auth.uid), "userRef");
        }
    },

    getChildContext() {
        if (!this.areAllBindingsLoaded()) {
            return false;
        }
        return {
            userRef: this.state.userRef,
            firebaseRoot: firebaseRoot
        };
    },

    render() {
        if (!this.areAllBindingsLoaded()) {
            return <div>Loading...</div>;
        }
        return this.props.children;
    }
});

export default UserRef;


/** WEBPACK FOOTER **
 ** ./src/UserRef.js
 **/